import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "#/stores/auth";

/**
 * Auth layout for public authentication pages
 * Redirects to dashboard if user is already authenticated
 */
export function AuthLayout() {
	const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
	const isLoading = useAuthStore((state) => state.isLoading);
	const location = useLocation();

	if (isLoading) {
		return (
			<main
				style={{
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
					justifyContent: "center",
					gap: "1rem",
					minHeight: "70vh",
				}}
			>
				<p>Loading...</p>
			</main>
		);
	}

	// If already authenticated, redirect to dashboard
	if (isAuthenticated) {
		const from = (location.state as { from?: string })?.from || "/";
		return <Navigate to={from} replace />;
	}

	return (
		<main
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				gap: "1rem",
				minHeight: "70vh",
				flex: 1,
			}}
		>
			<Outlet />
		</main>
	);
}
